import { Record } from 'immutable';

export default class AddressRecord extends Record({
    id: null,
    account_id: null,
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: ''
  }) {
    
  }
